module.exports = __webpack_public_path__ + "media/assets/partners/golden_io-d7837932f294c4e3ceedba2cb6915d7e.svg";